import { combineReducers } from '@reduxjs/toolkit';
import channel from './channelAppSlice';

const reducer = combineReducers({
  channel,
});

export default reducer;
